export default __webpack_public_path__ + "static/media/cancelledJob.4d774bdf.svg";